import { createContext } from 'react';
export var currentPrimaryDimensionContext = createContext('');
